import { IFileAttachment, IImpersonationContext, IPostTarget } from '../../../../extViewmodels';
import { asModalComponent } from '../../Modal';
import { PreviewSocialMediaPost } from '../PreviewSocialMediaPost';
import { styleSheet } from './styles';

export interface IProps {
	selectedTargets?: IPostTarget[];
	impersonationCtx: IImpersonationContext;
	postContent?: string;
	postImages?: IFileAttachment[];
}

function _PreviewSocialMediaPostModal({ selectedTargets, impersonationCtx, postContent, postImages }: IProps) {
	return (
		<PreviewSocialMediaPost
			postTargets={selectedTargets}
			styles={[styleSheet.modalContainer]}
			impersonationCtx={impersonationCtx}
			postContent={postContent}
			postImages={postImages}
		/>
	);
}

export const PreviewSocialMediaPostModal = asModalComponent(_PreviewSocialMediaPostModal, {
	className: 'preview-social-media',
	useDefaultHeader: true,
});
